<template>
</template>

<script>
import Vue from 'vue';

export default Vue.component('set-access-establishment-modal', {
    props: {
        establishmentId: Number,
        isAccessible: Boolean,
        visible: Boolean
    },
    data() {
        return {
            innerVisible: false
        }
    },
    mounted: function() {
    },
    methods: {
        reset() {
        },
        cancel() {
            this.innerVisible = false;
            this.reset();
        },
        end() {
            this.$http.post(`/api/establishment/${this.establishmentId}/setaccess`, { isAccessible: this.isAccessible }).then((response) => {
                this.$swal({
                    type: 'success',
                    title: 'Modification enregistrée'
                }).then(() => {

                });

                //reset form
                this.cancel();

                this.$root.$emit('pcr_update_data');
                this.$root.$emit('pcr_update_tree');
            }, this.cancel());
        }
    },
    watch: {
        innerVisible(val) {
            if(this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            this.innerVisible = val;
            console.log('visible');
            console.log(val);
            if(!val) {
                this.reset();
            }
            else {
                this.$swal({
                    type: 'warning',
                    title: this.isAccessible ? 'Dossier visible' : 'Dossier confidentiel',
                    text: this.isAccessible 
                        ? 'Etes-vous sûr de vouloir rendre ce dossier visible pourr les administrateurs ?'
                        : 'Etes-vous sûr de vouloir rendre ce dossier confidentiel pour les administrateurs ?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler'
                }).then(() => {
                    this.end();
                });
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/set-access-establishment-modal.vue